export default __webpack_public_path__ + "static/media/A28B0423-52C3-4B6D-A8D7-45D7A9BD594D.3589cdf0.jpeg";